module.exports = __webpack_public_path__ + "static/media/main_visual_articulated_loader_mla_6_65_h_z_manitou.839b2f8b.png";